import { Link, Paragraph, SkeletonLoader } from 'component-library';
import { useTranslation } from 'react-i18next';
import { type BranchContactType } from '@sr/types';
import { BranchCardInnerColumn, BranchCardRow, BranchInfoCard } from './styles';

export type BranchInfoMarkupProps = {
  branchInfo?: BranchContactType | null;
  loading: boolean;
  customMailTo?: string;
};

const defaultEmail = 'kundsupport.goteborg@stenarecycling.se';

export const BranchInfo = ({ branchInfo, loading, customMailTo }: BranchInfoMarkupProps) => {
  const { t } = useTranslation();

  const email = branchInfo?.email ? branchInfo.email : defaultEmail;

  if (loading) {
    return (
      <BranchInfoCard>
        <SkeletonLoader height="144px" />
      </BranchInfoCard>
    );
  }

  const mailTo = customMailTo ?? email;

  return (
    <BranchInfoCard>
      <BranchCardRow>
        <BranchCardInnerColumn>
          <Paragraph variant="large">{t('name')}</Paragraph>
          <Paragraph variant="large"> {branchInfo?.name}</Paragraph>
        </BranchCardInnerColumn>
        <BranchCardInnerColumn>
          <Paragraph variant="large">{t('address')}</Paragraph>
          <Paragraph variant="large">{branchInfo?.address}</Paragraph>
          <Paragraph variant="large">{branchInfo?.city}</Paragraph>
        </BranchCardInnerColumn>
      </BranchCardRow>
      <BranchCardRow>
        <BranchCardInnerColumn>
          <Paragraph variant="large">{t('phone')}</Paragraph>
          <Paragraph variant="large">
            <Link inline href={`tel:${branchInfo?.phone}`}>
              {branchInfo?.phone}
            </Link>
          </Paragraph>
        </BranchCardInnerColumn>
        <BranchCardInnerColumn>
          <Paragraph variant="large">{t('email')}</Paragraph>
          <Paragraph variant="large">
            <Link inline href={`mailto:${mailTo}`}>
              {email}
            </Link>
          </Paragraph>
        </BranchCardInnerColumn>
      </BranchCardRow>
    </BranchInfoCard>
  );
};
